// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class RemovePrescriberRequestModel {
    static getAttributeTypeMap() {
        return RemovePrescriberRequestModel.attributeTypeMap;
    }
}
RemovePrescriberRequestModel.discriminator = undefined;
RemovePrescriberRequestModel.attributeTypeMap = [
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    }
];
//# sourceMappingURL=removePrescriberRequestModel.js.map